export default "assets/images/icons/phone-b5eaa777.svg";